import React, { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { DOCUMENT_LIST_TYPE } from '../../../constants/constants';
import LabelValueItem from '../../../modules/label-value-item/label-value-item';
import LoadDocBtn from '../../../modules/load-doc-btn';
import IssueApi from '../../../services/api/IssueApi';
import { RootState } from '../../../types';
import {
  downloadFile,
  getPdfFromBase64,
} from '../../../utils/files/downloadFile';

const ListType = {
  [DOCUMENT_LIST_TYPE.DECISION]: 'Решение о выпуске:',
  [DOCUMENT_LIST_TYPE.SIGNED_DECISION]: 'Подпись решения:',
  [DOCUMENT_LIST_TYPE.PAYMENT_REQUIRED]: 'Документ о приобретении токена:',
  [DOCUMENT_LIST_TYPE.PAYMENT_SIGNED]: 'Подпись документа о приобретении:',
};

interface IItemList {
  name?: string;
  type?: DOCUMENT_LIST_TYPE;
  docId?: number;
  title?: string;
  value?: string | number | ReactNode;
}

interface AssetsDetailsListProps {
  isDocsList?: boolean;
  list: IItemList[];
  title: string;
}

const AssetsDetailsList: FC<AssetsDetailsListProps> = ({
  isDocsList,
  list,
  title,
}) => {
  const token = useSelector((s: RootState) => s.auth.account.token);

  const handleDownloadFile = async (item: IItemList) => {
    if (item.docId) {
      const docResponse = await IssueApi.getIssueDoc(
        token,
        item.docId,
        undefined,
        'application/pdf'
      );
      if (docResponse.status === 200) {
        const resultBlob = getPdfFromBase64(
          btoa(String.fromCharCode(...new Uint8Array(docResponse.data)))
        );
        downloadFile(resultBlob, item.name || '', 'application/pdf');
      }
    }
  };

  const renderList = () => {
    if (isDocsList) {
      return list.map((item: IItemList, index: number) => (
        <div
          className="assets-details__item assets-details__item--mb-lg"
          key={`assets-details__item-isDocsList-${index}`}
        >
          <div className="form-item">
            {item.type && (
              <div className="item__title">{ListType[item.type]}</div>
            )}
            <LoadDocBtn
              title={item.name || ''}
              extension={item.type === 'SIGNED_DECISION' ? '.SIG' : '.PDF'}
              onSpecDownload={() => handleDownloadFile(item)}
            />
          </div>
        </div>
      ));
    }

    return list.map((item: IItemList, index: number) => (
      <div
        className="assets-details__item"
        key={`assets-details__item-${index}`}
      >
        <LabelValueItem title={item.title || ''} text={item.value || ''} />
      </div>
    ));
  };

  return (
    <>
      <h2 className="text-2 assets-details__title">{title}</h2>
      {renderList()}
    </>
  );
};

export default AssetsDetailsList;
